import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { firePixelServer } from 'actions/pixelServer';
import {
  changeShippingAddress,
  fetchShippingInfo,
  resetShippingForm,
  updateMailingAddressOrName,
  updateShippingPhone
} from 'actions/account/shipping';
import AccountHeader from 'containers/account/AccountHeader';
import AccountBreadcrumbs from 'components/account/AccountBreadcrumbs';
import BackNav from 'components/account/BackNav';
import ShippingForm from 'components/account/ShippingForm';
import SiteAwareMetadata from 'components/SiteAwareMetadata';
import { PageLoader } from 'components/Loader';

import styles from 'styles/containers/account/editShipping.scss';

const links = [{ text: 'Shipping Information', to: '/addresses' }];

export class EditShipping extends Component {
  componentDidMount() {
    const {
      firePixelServer,
      shipping: {
        address: { addressId }
      }
    } = this.props;

    if (!addressId) {
      this.fetchData();
    }

    firePixelServer('my-account', {}, 'addresses-edit');
  }

  fetchData() {
    const {
      match: {
        params: { addressId }
      },
      fetchShippingInfo
    } = this.props;
    fetchShippingInfo(addressId, `/addresses/${addressId}/edit`);
  }

  render() {
    const { shipping, changeShippingAddress, updateMailingAddressOrName, updateShippingPhone, resetShippingForm } = this.props;
    const {
      address: { addressId }
    } = shipping;

    if (!addressId) {
      return <PageLoader centered={true} />;
    }

    return (
      <SiteAwareMetadata>
        <div className={styles.editShipping}>
          <BackNav to="/addresses">Shipping Information</BackNav>
          <AccountBreadcrumbs links={links} currentText="Edit Address" />
          <AccountHeader title="Edit Address" showCustomerEmail={false} />
          <ShippingForm
            shipping={shipping}
            onChangeShippingAddress={changeShippingAddress}
            onUpdateMailingAddressOrName={updateMailingAddressOrName}
            onUpdateShippingPhone={updateShippingPhone}
            onResetShippingForm={resetShippingForm}
          />
        </div>
      </SiteAwareMetadata>
    );
  }
}

EditShipping.contextTypes = {
  testId: PropTypes.func
};

const mapStateToProps = state => ({
  shipping: state.shipping
});

export default connect(mapStateToProps, {
  fetchShippingInfo,
  changeShippingAddress,
  updateMailingAddressOrName,
  updateShippingPhone,
  resetShippingForm,
  firePixelServer
})(EditShipping);
